import gql from 'fraql'
export default {
  CANCEL_ORDER: gql`
  mutation cancelOrder ($idOrder: Int!, $cancelComment: String!, $repeatingOrder: Boolean) {
    cancelOrder(input: {idOrder: $idOrder, cancelComment: $cancelComment, repeatingOrder: $repeatingOrder}) {
      clientMutationId
    }
  }`,
  TRY_OPEN_ORDER: gql`
  mutation tryOpenOrder ($idOrder: Int!) {
    tryOpenOrder(input: { orderId: $idOrder }) {
      boolean
    }
  }
  `,
  UPDATE_ORDER: gql`
  mutation updateOrderFunc($id: Int!, $patch: PatchUpdateOrderInput!) {
    apiUpdateOrderById(input: {id: $id, patch: $patch}) {
      boolean
    }
  }
  `,
  CREATE_ORDER_WITH_PRODUCTS: gql`
  mutation createOrderWithProducts($order: OrderInfoInput!, $products: [ProductInfoInput]!) {
    createOrderWithProducts(input: {order: $order, products: $products}) {
      order {
        id,
        idDay,
        pricePoints: sumPoints,
      }
    }
  }`,
  UPDATE_ORDER_WITH_PRODUCTS: gql`
    mutation updateOrderWithProducts($order: OrderInfoInput!, $products: [ProductInfoInput]!) {
      updateOrderWithProducts(input: {orderP: $order, products: $products}) {
        order {
          id,
          idDay
        }
      }
    }
  `,
  UPDATE_BALANCE_USER: gql`
    mutation updateBalanceUser($idOrder: Int!, $sum: Int!, $type: String, $comment: String) {
      updateBalanceUser(input: {
        idOrder: $idOrder,
        sum: $sum,
        type: $type,
        comment: $comment,
      }) {
        integer
      }
    }
  `
}



// WEBPACK FOOTER //
// ./src/graphql/commonForOrders.js